module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Bold.ttf";